import React, { memo, useMemo } from 'react'

import ClosedButtonSettings from 'Pods/ThreeDStudio/Shared/ClosedButtonSettings/ClosedButtonSettings'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

const LABEL = 'Polycount'

function CollapsedPolyCountRow() {
  const isDisabled = useThreeDStudioStore(state => {
    const uiSchema = state.schema.generationModelSchema.ui_schema || {}
    const { face_count: faceCountSchema, target_polycount: targetPolycountSchema } = uiSchema || {}

    return faceCountSchema?.['ui:options']?.disabled || targetPolycountSchema?.['ui:options']?.disabled
  })
  const targetPolycount = useThreeDStudioStore(state => state.modelSettings.targetPolycount)
  const polygonType = useThreeDStudioStore(state => state.modelSettings.polygonType)
  const faceCountSchema = useThreeDStudioStore(
    state => state.schema?.generationModelSchema?.input_schema?.properties?.face_count,
  )
  const targetPolycountSchema = useThreeDStudioStore(
    state => state.schema?.generationModelSchema?.input_schema?.properties?.target_polycount,
  )

  const polyCountSchema = useMemo(() => {
    const schema = faceCountSchema || targetPolycountSchema
    const schemaKey = faceCountSchema ? 'face_count' : 'target_polycount'

    if (schema?.oneOf) {
      const matched = schema.oneOf.find(
        entry => entry?.if?.properties?.polygon_type?.const === polygonType,
      )

      if (matched) {
        return matched?.then?.properties?.[schemaKey]
      }
    }

    return schema
  }, [faceCountSchema, targetPolycountSchema, polygonType])

  const { minimum, default: defaultValue, maximum } = polyCountSchema || {}

  let presetLabel
  if (targetPolycount === minimum) {
    presetLabel = 'Low'
  } else if (targetPolycount === defaultValue) {
    presetLabel = 'Medium'
  } else if (targetPolycount === maximum) {
    presetLabel = 'High'
  }

  if (presetLabel) {
    return (
      <ClosedButtonSettings
        label={LABEL}
        isActive
        disabled={isDisabled}
        buttonLabel={presetLabel}
      />
    )
  }

  return (
    <div className="collapsed-model-settings__row">
      <span className="collapsed-model-settings__title">{LABEL}</span>
      <span className="collapsed-model-settings__numeric-value cgt-body-base">
        {targetPolycount}
      </span>
    </div>
  )
}

export default memo(CollapsedPolyCountRow)
